/**
 * Copyright (c) 2022, WSO2 LLC. (https://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
 * You may not alter or remove any copyright or other notice from copies of this content.
 */

import React, { FunctionComponent, ReactElement } from "react";
import { Loader } from "rsuite";
import { IdentifiableComponentInterface } from "../models";

/**
* Application Global loading component props interface.
*/
type GlobalLoaderPropsInterface = IdentifiableComponentInterface;

/**
* Application Global loading component.
*
* @param {GlobalLoaderPropsInterface} props - Props injected to the component.
* @return {React.ReactElement}
*/
export const GlobalLoader: FunctionComponent<GlobalLoaderPropsInterface> = (
    props: GlobalLoaderPropsInterface
): ReactElement => {

    const {
        ["data-componentid"]: componentId
    } = props;

    return <Loader data-componentid={ componentId } backdrop content="Loading.." />;
};
